import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { formatChartTickValue } from '../../utils/chartFormatUtils';

export default function MetricSummary({ metrics = [] }) {
  return (
    <Stack divider={<Divider flexItem />}>
      {metrics.map((item) => (
        <Stack
          key={item.id}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{ py: 1.25 }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            {item.count != null ? (
              <Typography variant="caption" color="text.disabled" sx={{ display: 'block' }}>
                n={formatChartTickValue(item.count)}
              </Typography>
            ) : null}
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '-0.02em', flexShrink: 0 }}>
            {item.display || formatChartTickValue(item.value) || '0'}
          </Typography>
        </Stack>
      ))}
      {!metrics.length ? (
        <Box sx={{ py: 3 }}>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            0
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
}
